import {
  SET_THREAD_ID,
  SET_THREAD_MEMBERS,
  SET_THREAD_CHATS,
  SET_THREAD_FILTER,
  SET_THREAD_CHAT_SCREEN,
  SET_THREAD_SUBMISSION_DATA,
  SET_THREAD_ESG_COMPLIANCE_ID,
} from "constants/thread/threadConst";

const initial_state = {
  thread_id: null,
  assessment_id: null,
  members: [],
  thread_chats: [],
  idToIndex: {},
  thread_filter: null, // {type: "sort", value: ""}
  chat_screen: null, // {screen: "SUBMISSION", chat: {...chat}}
  selected_submission_data: null,
  notification: {},
  typingUsers: [],
  onlineUsers: [],

  messageById: {}, // { [msgId]: messageObject }
  orderedIds: [], // [msgId1, msgId2, ...] in order, oldest first
  nextCursor: null, // for pagination
  hasMore: false,
};

export default function reducer(state = initial_state, action) {
  switch (action.type) {
    // case "RESET_STATE":
    //   return (state = {
    //     ...state,
    //     ...initial_state,
    //   });
    case SET_THREAD_ID:
      return {
        ...state,
        thread_id: action.payload,
      };
    case "SET_THREAD_NOTIFICATION":
      return {
        ...state,
        notification: { ...state.notification, ...action.payload },
      };

    case SET_THREAD_ESG_COMPLIANCE_ID:
      return {
        ...state,
        assessment_id: action.payload,
      };

    case SET_THREAD_MEMBERS:
      return {
        ...state,
        members: action.payload,
      };

    case "SET_THREAD_CHATS": {
      const {
        messageById: newMessages = {},
        orderedIds: newIds = [],
        append = false,
        nextCursor = null,
        hasMore = false,
      } = action.payload;

      console.groupCollapsed(
        `%c[REDUCER] SET_THREAD_CHATS %c(append=${append})`,
        "color: #00bfff; font-weight: bold;",
        "color: gray;"
      );

      const currentMessages = state.messageById || {};
      const currentOrderedIds = state.orderedIds || [];

      // Merge messages
      const mergedMessageById = { ...currentMessages, ...newMessages };
      let mergedOrderedIds;

      mergedOrderedIds = [
        ...new Set(
          append
            ? [...currentOrderedIds, ...newIds]
            : [...newIds, ...currentOrderedIds]
        ),
      ];

      console.groupEnd();

      return {
        ...state,
        messageById: mergedMessageById,
        orderedIds: mergedOrderedIds,
        nextCursor,
        hasMore,
      };
    }

    case SET_THREAD_FILTER:
      return {
        ...state,
        thread_filter: action.payload,
      };

    case SET_THREAD_CHAT_SCREEN:
      return {
        ...state,
        chat_screen: action.payload,
      };

    case SET_THREAD_SUBMISSION_DATA:
      return {
        ...state,
        selected_submission_data: action.payload,
      };

    case "SET_USER_TYPING": {
      const exists = state.typingUsers.some(
        (u) => u.user_id === action.payload.user_id
      );
      if (exists) return state;

      return {
        ...state,
        typingUsers: [
          ...state.typingUsers,
          { user_id: action.payload.user_id, name: action.payload.name },
        ],
      };
    }

    case "SET_USER_STOP_TYPING": {
      return {
        ...state,
        typingUsers: state.typingUsers.filter(
          (u) => u.user_id !== action.payload.user_id
        ),
      };
    }

    case "UPDATE_MESSAGES_DELIVERY": {
      const { updates = [] } = action.payload;
      const currentMessages = state.messageById || {};
      
      // 🔥 O(k) BATCH UPDATE where k = updates.length (typically 1-10)
      // NO array operations, just object updates!
      const updatedMessages = { ...currentMessages };

      for (const { _id, delivered_to } of updates) {
        if (updatedMessages[_id]) {
          updatedMessages[_id] = {
            ...updatedMessages[_id],
            delivered_to: [...delivered_to],
          };
        }
      }

      return {
        ...state,
        messageById: updatedMessages,
        // ✅ orderedIds UNTOUCHED = Zero array operations = O(1)!
      };
    }

    case "CLEAR_THREAD_CHATS": {
      
      return {
        ...state,
        messageById: {},
        orderedIds: [],
        nextCursor: null,
        hasMore: true,
        members: [],
      };
    }
    case "SET_ONLINE_USERS":
      return {
        ...state,
        onlineUsers: action.payload || [],
      };

    default:
      return state;
  }
}
